module.exports = __webpack_public_path__ + "static/media/6_Waiting lounge-Sanyukansahoujin - Japan.3690eef7.jpg";